import { getPositionList, getOrderHistoryList, getOpenOrderList, postCancelOrder, postCancelOrderAll, postPositionTpsl, postClosePositionAll, getPositionHistoryList, postClosePosition } from '@/api/trading/apiUserHistory';
export default {
    namespaced: true,
    state: {
        positionList: [],
        positionHistoryList: [],
        orderHistoryList: [],
        openOrderList: [],
        positionPnlList : [],
        reCode : 0,
        hideOtherSymbol : false,
        date : {},
    },
    mutations: {
        setPositionList(state, payload) {
            state.positionList = payload;         
        },
        setPositionHistoryList(state, payload) {
            state.positionHistoryList = payload;         
        },
        setOrderHistoryList(state, payload) {
            state.orderHistoryList = payload;
        },
        setOpenOrderList(state, payload) {
            state.openOrderList = payload;
        },
        setPositionPnlList(state, payload) {
            state.positionPnlList = payload;
        },
        setRecode(state,payload){
            state.reCode = payload;
        },
        setHideOtherSymbol(state, payload) {
            state.hideOtherSymbol = payload;
        },
        setDate(state,{ s, e }){
            state.date = {
                start : s,
                end : e,
            }
        }
    },
    actions: {
        async getPositionList(context, userNo) {
            const response = await getPositionList(userNo);
            context.commit("setPositionList", response);
        },
        async getPositionHistoryList(context, userNo) {
            const response = await getPositionHistoryList(userNo);
            context.commit("setPositionHistoryList", response);
        },
        async getOrderHistoryList(context, userNo) {
            const response = await getOrderHistoryList(userNo);
            context.commit("setOrderHistoryList", response);
        },
        async getOpenOrderList(context, userNo) {
            const response = await getOpenOrderList(userNo);
            context.commit("setOpenOrderList", response);
        },
        async postCancelOrder(context, {userNo,ordid}) {
            const response = await postCancelOrder(userNo,ordid);
            context.commit("setRecode", response?.reCode);
        },
        async postCancelOrderAll(context, {userNo,ordid}) {
            const response = await postCancelOrderAll(userNo,ordid);
            context.commit("setRecode", response?.reCode);
        },
        async postClosePositionAll(context, userNo) {
            const response = await postClosePositionAll(userNo);
            context.commit("setRecode", response?.reCode);
        },
        async postClosePosition(context, {userNo,positionId}) {
            const response = await postClosePosition(userNo,positionId);
            context.commit("setRecode", response?.reCode);
        },
        async postPositionTpsl(context, info) {
            const queryString = new URLSearchParams(info).toString();
            const response = await postPositionTpsl(queryString);
            context.commit("setRecode", response?.reCode);
        },
        async fetchAllHistory(context, userNo) {
            try {
              await Promise.all([
                context.dispatch("getPositionList", userNo),
                context.dispatch("getPositionHistoryList", userNo),
                context.dispatch("getOrderHistoryList", userNo),
                context.dispatch("getOpenOrderList", userNo),
              ]);
            } catch (error) {
              console.error("Fetch history failed:", error);
            }
          },
    },
}
